module.exports = __webpack_public_path__ + "img/13.ede29aa8.webp";